export const SHOP_ITEMS = {
  // powerups: {
  //   bomb: {
  //     id: "bomb",
  //     name: "Bomb",
  //     description: "Destroys nearby circles",
  //     cost: 50,
  //     type: "powerup"
  //   },
  //   addBall: {
  //     id: "addBall",
  //     name: "Extra Ball",
  //     description: "Adds an additional ball",
  //     cost: 75,
  //     type: "powerup"
  //   },
  //   clearRows: {
  //     id: "clearRows",
  //     name: "Row Clear",
  //     description: "Clears multiple rows",
  //     cost: 100,
  //     type: "powerup"
  //   }
  // },
  // bundles: {
  //   starter: {
  //     id: "starter",
  //     name: "Starter Bundle",
  //     description: "Perfect for beginners!",
  //     cost: 150,
  //     contents: {
  //       bomb: 2,
  //       addBall: 2,
  //       clearRows: 1
  //     },
  //     savings: "25% OFF!"
  //   },
  //   premium: {
  //     id: "premium",
  //     name: "Premium Bundle",
  //     description: "Best value for power players!",
  //     cost: 300,
  //     contents: {
  //       bomb: 5,
  //       addBall: 5,
  //       clearRows: 3
  //     },
  //     savings: "35% OFF!"
  //   }
  // }
};
